//  That settings have default template view settings
export const SETTINGS = {
  boxed: true, // boolean                             //content'in daralmasi ile ilgili
  layout: 'vertical', // horizontal | vertical        // navigation item'larin dikey veya yatay olarak duzenlenmesi
  sidebarBg: '#cd5447', // string                     // sidebar background color 1
  sidebarBg2: '#9d5ce5', // string                    // sidebar background color 2
  sidebarColor: '#ffffff', // string                  // sidebar text color
  sidebarAccentColor: '#7EDECC', // string            // sidebar accent color (selected item background)
  sidebarAccentContrastColor: '#8b572a', // string    // sidebar accent contrast color (selected item background)
  sidebarOpened: false, // boolean
  topbarBg: '#ffffff', // string                      // topbar background color
  topbarColor: '#4a505c' // string                    // sidebar text color
};
